import {useState} from 'react';
import SafeIcon from '../common/SafeIcon';
import Reveal from './Reveal';
import OptimizedImage from './OptimizedImage';
import {useSiteImages} from '../hooks/useSiteImages';
import RoomBookingOptions from '../pages/RoomBookingOptions';

function Hero() {
  const [ready, setReady] = useState(false);
  const {url} = useSiteImages();
  const POSTER = url('hero_poster');
  const VIDEO = url('hero_video');
  return (
    <section className="hero" id="home">
      <OptimizedImage className="hero__poster" src={POSTER} alt="" loading="eager" fetchPriority="high" sizes="100vw" width={2200} height={1000} />
      <video
        className={`hero__video ${ready ? 'is-ready' : ''}`}
        src={VIDEO}
        poster={POSTER || undefined}
        autoPlay
        loop
        muted
        playsInline
        preload="metadata"
        onCanPlay={() => setReady(true)}
      />
      <div className="hero__shade" />
      <span className="leaf leaf--1" />
      <span className="leaf leaf--2" />
      <span className="leaf leaf--3" />
      <div className="hero__content">
        <Reveal>
          <span className="eyebrow eyebrow--light">THE WILD, WITH A SOFTER SIDE</span>
          <h1>Experience the bliss<br /><em>of luxury</em></h1>
          <p>A peaceful safari escape in the heart of Yala National Park Buffer Zone.</p>
          <div className="hero__actions">
            <RoomBookingOptions
              roomName="your stay"
              buttonLabel="Book your stay"
              onWebsite={() => window.dispatchEvent(new Event('open-enquiry'))}
            />
            <a className="button button--glass" href="#rooms">Explore rooms</a>
          </div>
        </Reveal>
      </div>
      <a className="scroll-cue" href="#about"><span />Scroll to discover</a>
      <span className="hero__caption">6° 22′ N &nbsp;81° 17′ E · TISSAMAHARAMA</span>
    </section>
  );
}

export default Hero;